import { addEdge, Edge, OnConnect, useReactFlow } from "@xyflow/react";
import { FormValues } from "features/entities/EntityCreatePage/EntityCreatePage";
import { getEdgeId } from "features/entities/EntityCreatePage/EntityGraph/edges/edgeUtils";
import { AppEdge } from "features/entities/EntityCreatePage/EntityGraph/edges/types";
import { DRAFT_NODE_ID } from "features/entities/EntityCreatePage/EntityGraph/entityGraphConstants";
import reject from "lodash-es/reject";
import { useCallback, useMemo } from "react";
import { useFormContext } from "react-hook-form";

export const useFormSync = () => {
  const form = useFormContext<FormValues>();
  const { setEdges } = useReactFlow();

  const onEdgesDelete = useCallback(
    (edgesToDelete: Edge[]) => {
      edgesToDelete.forEach((edge) => {
        const outgoingEdge = edge.source === DRAFT_NODE_ID;

        if (outgoingEdge) {
          form.setValue(
            "investing_into_entities",
            reject(
              form.getValues("investing_into_entities"),
              (val) => val === edge.target,
            ),
          );
        }
      });
    },
    [form],
  );

  const onConnect: OnConnect = useCallback(
    (connection) => {
      const newEdge: AppEdge = {
        id: getEdgeId(connection.source, connection.target),
        animated: [connection.source, connection.target].includes(
          DRAFT_NODE_ID,
        ),
        ...connection,
      };
      const outgoingEdge = newEdge.source === DRAFT_NODE_ID;
      if (outgoingEdge) {
        form.setValue("investing_into_entities", [
          ...form.getValues("investing_into_entities"),
          newEdge.target,
        ]);
      }

      setEdges((edges) => addEdge(newEdge, edges));
    },
    [form, setEdges],
  );

  return useMemo(
    () => ({ onEdgesDelete, onConnect }),
    [onEdgesDelete, onConnect],
  );
};
